import React from "react";
import { FaExternalLinkAlt } from "react-icons/fa";
import { Link } from "react-router-dom";

export default function SingleVerticalElevator() {
  return (
    <div className="single-vertical-parent">
      <div className="vertical-title">
        <div className="text-900 font-bold text-7xl mb-4 text-center">
          FlexNet Elevator: Elevating Connectivity for Smarter, Safer Operations
        </div>
        <div className="text-700 text-xl mb-6 text-center line-height-3">
          Seamless 4G/5G connectivity for predictive maintenance, in-cabin
          entertainment, and emergency communications in elevators.
        </div>
      </div>
      {/* Hero Section */}
      <div className="grid grid-nogutter surface-section text-800 ">
        <div className="col-12 md:col-6 p-6 text-center md:text-left flex align-items-center">
          <section>
            <span className="block text-6xl font-bold mb-3">
              FlexNet Elevator
            </span>
            <div className="text-6xl text-primary font-bold mb-3">
              Revolutionizing Operations with 5G Connectivity
            </div>
            <p className="mt-0 mb-4 text-700 line-height-3">
              Empower elevator systems with FlexNet Elevator. Our 4G/5G
              solutions ensure real-time monitoring, enhanced passenger safety,
              and in-cabin digital experiences.
            </p>
            <button className="flex underline align-items-center mt-4">
              <Link to="/connectivity">Request Demo</Link>
              <FaExternalLinkAlt className="ml-2" />
            </button>
          </section>
        </div>
        <div className="col-12 md:col-6 overflow-hidden">
          <img
            src="https://www.shutterstock.com/image-illustration/abstract-3d-city-rendering-lines-600nw-478962811.jpg"
            alt="hero-1"
            className="md:ml-auto block md:h-full"
            style={{ clipPath: "polygon(8% 0, 100% 0%, 100% 100%, 0 100%)" }}
          />
        </div>
      </div>

      {/* Key Benefits Section */}
      <div className="surface-section px-4 py-8 md:px-6 lg:px-8 text-center">
        <div className="mb-3 font-bold text-3xl">
          <span className="text-900">Why </span>
          <span className="text-blue-600">FlexNet for Elevator?</span>
        </div>
        <div className="grid justify-center">
          {keyBenefits.map((benefit, index) => (
            <div key={index} className="col-12 md:col-4 mb-4 px-5">
              <span
                className="p-3 shadow-2 mb-3 inline-block surface-card"
                style={{ borderRadius: "10px" }}
              >
                <i className={`${benefit.icon} text-4xl text-blue-500`}></i>
              </span>
              <div className="text-900 text-xl mb-3 font-medium">
                {benefit.title}
              </div>
              <span className="text-700 line-height-3">{benefit.detail}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Use Cases Section */}

      <div className="mb-3 font-bold text-3xl">
        <span className="text-900">FlexNet Elevator </span>
        <span className="text-blue-600">Use Cases</span>
      </div>
      {useCases.map((useCase, index) => (
        <div
          key={index}
          className="surface-section px-4 py-8 md:px-6 lg:px-8 text-center"
        >
          <div className="b-3 font-bold text-2xl mb-3">
            <span className="text-blue-600">Use Case</span>
            {useCase.title}
          </div>
          <div className="text-700 mb-6">{useCase.description}</div>
          <div className="grid">
            <div className="col-12 md:col-4 mb-4 px-5">
              <div className="text-900 text-xl mb-3 font-medium">Benefits</div>
              {useCase.benefits.map((item, idx) => (
                <div key={idx} className="mb-2">
                  <i className={`${item.icon} text-blue-500 mr-2`}></i>
                  {item.title}
                </div>
              ))}
            </div>
            <div className="col-12 md:col-4 mb-4 px-5">
              <div className="text-900 text-xl mb-3 font-medium">
                Devices/Technologies
              </div>
              {useCase.devices.map((item, idx) => (
                <div key={idx} className="mb-2">
                  <i className={`${item.icon} text-blue-500 mr-2`}></i>
                  {item.title}
                </div>
              ))}
            </div>
            <div className="col-12 md:col-4 mb-4 px-5">
              <div className="text-900 text-xl mb-3 font-medium">
                Applications
              </div>
              {useCase.applications.map((item, idx) => (
                <div key={idx} className="mb-2">
                  <i className={`${item.icon} text-blue-500 mr-2`}></i>
                  {item.title}
                </div>
              ))}
            </div>
            <button className="flex underline align-items-center mt-4 vertical-market-link">
              <Link to="/marketplace">Request Access to Marketplace</Link>
              <FaExternalLinkAlt className="ml-2" />
            </button>
          </div>
        </div>
      ))}

      {/* Case Studies Testimonias Section */}
      <div className="surface-section px-4 py-8 md:px-6 lg:px-8 text-center">
        <div className="mb-3 font-bold text-3xl">
          <span className="text-blue-600"> Key Technical Features</span>
        </div>
        <div className="grid justify-center">
          <div className="text-900 text-xl mb-3 font-medium"></div>
          <div className="technical-specifications">
            <div className="text-700 line-height-3 technical-specifications-box text-xl">
              <ul className="list-disc pl-5 mt-3">
                <li className="before:content-['\2022'] before:mr-2 before:text-blue-600">
                  Low-latency 4G/5G connectivity for real-time monitoring
                </li>
                <li className="before:content-['\2022'] before:mr-2 before:text-blue-600">
                  High-bandwidth support for multimedia content
                </li>
                <li className="before:content-['\2022'] before:mr-2 before:text-blue-600">
                  Redundant communication channels for emergency situations
                </li>
                <li className="before:content-['\2022'] before:mr-2 before:text-blue-600">
                  Secure data transmission protocols
                </li>
                <li className="before:content-['\2022'] before:mr-2 before:text-blue-600">
                  Easy integration with existing elevator systems
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Call-to-Action Section */}
      <div className="surface-section text-center py-8">
        <div className="text-900 text-3xl font-bold mb-4">
          Ready to Modernize Your Elevators?
        </div>

        <button className="p-button p-button-raised connectivity-request-demo-button p-3">
          <Link to="contact-page">Get in Touch for a Personalized Demo</Link>
        </button>
      </div>
    </div>
  );
}

const keyBenefits = [
  {
    title: "Predictive Maintenance for Reduced Downtime",
    detail:
      "Ensure proactive monitoring and fault detection to prevent unexpected failures.",
    icon: "pi pi-chart-line",
  },
  {
    title: "Enhanced Passenger Safety with Real-Time Emergency Communication",
    detail:
      "Enable secure and reliable communication for emergency situations.",
    icon: "pi pi-shield",
  },
  {
    title: "In-Cabin Wi-Fi and Entertainment Services",
    detail:
      "Provide seamless connectivity and multimedia experiences for passengers.",
    icon: "pi pi-wifi",
  },
  {
    title: "Remote Diagnostics and Performance Monitoring",
    detail:
      "Improve operational efficiency with continuous elevator monitoring.",
    icon: "pi pi-cog",
  },
  {
    title: "Secure, Low-Latency 4G/5G Connectivity",
    detail: "Ensure stable and high-speed network access for elevator systems.",
    icon: "pi pi-lock",
  },
];

const useCases = [
  {
    title: " 1: Predictive Maintenance and Remote Monitoring",
    description:
      "Enable real-time diagnostics and predictive maintenance for elevators, reducing the risk of unexpected breakdowns.",
    benefits: [
      {
        title: "Minimize downtime through proactive alerts",
        icon: "pi pi-bell",
      },
      {
        title: "Reduce maintenance costs with efficient service scheduling",
        icon: "pi pi-dollar",
      },
      {
        title: "Improve equipment lifespan with continuous monitoring",
        icon: "pi pi-clock",
      },
    ],
    devices: [
      { title: "IoT Sensors", icon: "pi pi-cloud" },
      { title: "4G/5G Routers", icon: "pi pi-wifi" },
      { title: "Cloud-based Monitoring Platforms", icon: "pi pi-server" },
    ],
    applications: [
      { title: "Remote Monitoring", icon: "pi pi-desktop" },
      { title: "Predictive Analytics", icon: "pi pi-chart-bar" },
      { title: "Fault Detection", icon: "pi pi-exclamation-triangle" },
    ],
  },
  {
    title: " 2: In-Cabin Entertainment and Connectivity",
    description:
      "Provide high-speed internet and digital entertainment solutions within elevator cabins for an enhanced passenger experience.",
    benefits: [
      {
        title: "Deliver real-time information displays and multimedia content",
        icon: "pi pi-desktop ",
      },
      {
        title: "Enable in-cabin Wi-Fi for passenger connectivity",
        icon: "pi pi-wifi",
      },
      {
        title: "Support smart building IoT integrations",
        icon: "pi pi-building",
      },
    ],
    devices: [
      { title: "4G/5G CPEs", icon: "pi pi-wifi" },
      { title: "Smart Displays", icon: "pi pi-desktop" },
    ],
    applications: [
      { title: "Digital Signage", icon: "pi pi-chart-bar" },
      { title: "In-Cabin Wi-Fi", icon: "pi pi-wifi" },
      { title: "Entertainment Systems", icon: "pi pi-play " },
    ],
  },
  {
    title: " 3: Emergency Communication Systems",
    description:
      "Ensure reliable emergency communication in elevators, even during power outages or network disruptions.",
    benefits: [
      {
        title: "Real-time two-way voice and video communication",
        icon: "pi pi-video",
      },
      {
        title: "Secure, redundant connectivity for critical situations",
        icon: "pi pi-lock",
      },
      {
        title: "Compliance with safety regulations for emergency preparedness",
        icon: "pi pi-check",
      },
    ],
    devices: [
      { title: "4G/5G Emergency Call Units", icon: "pi pi-phone" },
      { title: "Backup Power Modules", icon: "pi pi-bolt " },
    ],
    applications: [
      { title: "Emergency Call Systems", icon: "pi pi-phone" },
      { title: "Video Surveillance", icon: "pi pi-video" },
      { title: "Incident Reporting", icon: "pi pi-exclamation-triangle" },
    ],
  },
];
